// WU-2.1 — /api/announcements client. Paths WITHOUT the /api prefix
// (@/lib/api-client adds it). Shapes mirror the api routes exactly.
import { api } from "@/lib/api-client";
import type {
  AnnouncementLevel,
  AnnouncementAudience,
  AnnouncementRecord,
} from "@capture/shared";

export type { AnnouncementLevel, AnnouncementAudience, AnnouncementRecord };

export interface CreateAnnouncementPayload {
  body: string;
  level: AnnouncementLevel;
  audienceType: AnnouncementAudience;
  audienceUserId?: string;
  teamId?: string;
  expiresInHours?: number;
}

export const announcementsApi = {
  listMine: () =>
    api.get<{ announcements: AnnouncementRecord[]; viewerTeamIds?: string[] }>(
      "/announcements",
    ),
  listManage: () => api.get<{ announcements: AnnouncementRecord[] }>("/announcements/manage"),
  create: (payload: CreateAnnouncementPayload) =>
    api.post<{ announcement: AnnouncementRecord }>("/announcements", payload),
  clear: (id: string) => api.delete<{ cleared: boolean }>(`/announcements/${id}`),
  dismiss: (id: string) => api.post<void>(`/announcements/${id}/dismiss`, {}),
};
